export default {"src":"/_next/static/media/under_construction.b68508b1.svg","height":529,"width":968,"blurWidth":0,"blurHeight":0};